import { Paper } from "@mui/material";
import { FC, useEffect } from "react";
import styled from "styled-components";
import { useChat } from "../../hooks/useChat";
import { useInfo } from "../../hooks/useInfo";
import { useRemoteParticipant } from "../../hooks/useRemoteParticipant";
import DragAndDrop from "./DragAndDrop/DragAndDrop";
import ChatHeader from "./Header/Header";
import Messages from "./Messages/Messages";
import NewMessageForm from "./NewMessageForm/NewMessageForm";

const ChatContainer = styled("div")`
  display: ${(props) => (props.hidden ? "none" : "flex")};
  box-sizing: border-box;
  padding: 6px;
  height: 100%;
  min-width: 350px;
  z-index: auto;

  @container (max-width: 1100px) {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 100;
  }

  @container (max-width: 950px) {
    width: 100%;
    min-width: 100%;
  }
`;

const ChatWrapper = styled(Paper)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
`;

const ChatContent = styled("div")`
  height: 100%;
  padding: 5px;
  display: flex;
  flex-flow: column;
  min-height: 0;
`;

const Chat: FC = () => {
  const { chatOpen, handleChatOpen } = useChat();
  const { remoteParticipant } = useRemoteParticipant();
  const { telemedicineData } = useInfo();

  useEffect(() => {
    if (window.innerWidth > 1100 && telemedicineData.permission === "patient") {
      handleChatOpen(true);
    }
  }, [remoteParticipant]);

  return (
    <ChatContainer hidden={!chatOpen}>
      <DragAndDrop disabled={!remoteParticipant}>
        <ChatWrapper elevation={14}>
          <ChatHeader />
          <ChatContent>
            <Messages />
            {remoteParticipant && <NewMessageForm />}
          </ChatContent>
        </ChatWrapper>
      </DragAndDrop>
    </ChatContainer>
  );
};

export default Chat;
